let conversationContext = {
  currentFlow: null,
  collectedData: {},
  lastQueryWasFee: false
};

const FLOWS = {
  COURSE_INQUIRY: 'course_inquiry',
  ADMISSION: 'admission',
  CONTACT: 'contact'
};

const universityLeadership = {
  'chancellor': {
    name: "Doctor Yogesh Kumar",
    email: "chancellor@mindpoweruniversity.ac.in",
    position: "Chancellor"
  },
  'pro-chancellor': {
    name: "Brijesh Yadav",
    email: "prochancellor@mindpoweruniversity.ac.in",
    position: "Pro-Chancellor"
  },
  'Vice Chancellor': {
    name: "Doctor Shweta Bhosale",
    email: "info@mindpoweruniversity.ac.in",
    position: "Vice Chancellor"
  },
  'registrar': {
    name: "Hirdesh Kumar Yadav",
    email: "registrar@mindpoweruniversity.ac.in",
    position: "Registrar"
  }
};

// Helper functions
const createLink = (text, url) => {
  return `<a href="${url}" target="_blank" class="chat-link">${text}</a>`;
};

const getSpeechText = (text) => {
  if (typeof text !== 'string') return text;

  let result = text.replace(/<a\b[^>]*>(.*?)<\/a>/g, '$1');
  
  result = result
    .replace(/\./g, ' ')
    .replace(/_/g, ' ');
  
  return result; 
};

// Course Categories Mapping with all possible variations
const courseCategoriesMap = {
  // Management
  'management': 'management',
  'mba': 'management',
  'bba': 'management',
  'b.com': 'management',
  'bcom': 'management',
  'mcom': 'management',
  'm.com': 'management',
  'commerce': 'management',
  'business': 'management',

  // Engineering
  'engineering': 'engineering',
  'btech': 'engineering',
  'b.tech': 'engineering',
  'mtech': 'engineering',
  'm.tech': 'engineering',
  'diploma engineering': 'engineering',
  'aerospace': 'engineering',
  'drone': 'engineering',
  'ai': 'engineering',
  'ml': 'engineering',
  'machine learning': 'engineering',
  'data science': 'engineering',
  'cyber security': 'engineering',
  'mechanical': 'engineering',
  'electronics': 'engineering',
  'ev': 'engineering',
  'civil': 'engineering',

  // Computer & IT
  'computer': 'computer_application',
  'it': 'computer_application',
  'cs': 'computer_application',
  'bca': 'computer_application',
  'mca': 'computer_application',
  'computer science': 'computer_application',
  'ai ds': 'computer_application',
  'bsc computer': 'computer_application',

  // Humanities & Social Sciences
  'humanities': 'social_sciences',
  'social science': 'social_sciences',
  'arts': 'social_sciences',
  'ba': 'social_sciences',
  'ma': 'social_sciences',
  'msw': 'social_sciences',
  'mfa': 'social_sciences',
  'fine arts': 'social_sciences',
  'sociology': 'social_sciences',
  'psychology': 'social_sciences',

  // Applied Sciences
  'applied science': 'applied_sciences',
  'bsc microbiology': 'applied_sciences',
  'bsc biotechnology': 'applied_sciences',
  'msc chemistry': 'applied_sciences',
  'botany': 'applied_sciences',
  'physics': 'applied_sciences',
  'mathematics': 'applied_sciences',

  // Pharmacy
  'pharmacy': 'pharmacy',
  'dpharma': 'pharmacy',
  'bpharma': 'pharmacy',
  'medical': 'pharmacy',

  // Journalism & Media
  'journalism': 'journalism',
  'mass communication': 'journalism',
  'media': 'journalism',
  'bajmc': 'journalism',

  // Hospitality
  'hospitality': 'hospitality',
  'hotel': 'hospitality',
  'bhm': 'hospitality',
  'diploma hotel': 'hospitality',

  // Yoga & Naturopathy
  'yoga': 'yogic_science',
  'bnys': 'yogic_science',
  'naturopathy': 'yogic_science',
  'msc yogic': 'yogic_science',

  // Skill/Vocational
  'vocational': 'vocational',
  'bvoc': 'vocational',
  'dvoc': 'vocational',
  'mvoc': 'vocational',
  'radiology': 'vocational',
  'mlt': 'vocational',
  'pcm': 'vocational',
  'health info': 'vocational',

  // Agriculture
  'agriculture': 'agriculture',
  'bsc agriculture': 'agriculture',
  'msc agronomy': 'agriculture',

  // Earth Science & GIS
  'earth science': 'earth_science',
  'geography': 'earth_science',
  'remote sensing': 'earth_science',
  'gis': 'earth_science',

  // PhD
  'phd': 'phd',
  'doctorate': 'phd',
  'doctoral': 'phd',
  'research': 'phd',
  'p h d': 'phd',
  'PHD': 'phd',
  'p.h.d': 'phd'
};


// Course Level Mapping
const courseLevelMap = {
  'ug': 'undergraduate',
  'undergrad': 'undergraduate',
  'graduate': 'undergraduate',
  'bachelor': 'undergraduate',
  'bsc': 'undergraduate',
  'ba': 'undergraduate',
  'bcom': 'undergraduate',
  'bba': 'undergraduate',
  'bca': 'undergraduate',
  'btech': 'undergraduate',
  'bjmc': 'undergraduate',
  'bhm': 'undergraduate',
  'bnys': 'undergraduate',

  'pg': 'postgraduate',
  'postgrad': 'postgraduate',
  'master': 'postgraduate',
  'msc': 'postgraduate',
  'ma': 'postgraduate',
  'mcom': 'postgraduate',
  'mba': 'postgraduate',
  'mca': 'postgraduate',
  'mtech': 'postgraduate',
  'msw': 'postgraduate',
  'mfa': 'postgraduate',

  'diploma': 'diploma',
  'd.pharma': 'diploma',
  'dpharma': 'diploma',
  'dhm': 'diploma',

  'vocational': 'vocational',
  'bvoc': 'vocational',
  'dvoc': 'vocational',
  'mvoc': 'vocational',

  'phd': 'doctoral',
  'doctoral': 'doctoral',
  'doctorate': 'doctoral',
  'research': 'doctoral'
};

// Enhanced knowledgeBase with multi-word keywords
const knowledgeBase = [
  // Greetings
  {
    keywords: ['hi', 'hello', 'hey', 'namaste', 'good morning', 'good evening', 'kaise ho', 'hii', 'suno', 'helloo', 'oye', 'listen'],
    response: {
      displayText: "Hello! I'm your virtual assistant from Mind Power University. How can I help you today? You can ask me about courses, admissions, campus facilities, placements and scholarships.",
      speechText: "Hello! I'm your virtual assistant from Mind Power University. How can I help you today? You can ask me about courses, admissions, campus facilities, placements and scholarships."
    }
  },

  // University Information
  {
    keywords: ['about mind power university', 'about university', 'about Mind Power University', 'mind power university', 'mpu', 'what is mind power university', 'what is mpu', 'university introduction', 'university info', 'university details', 'mpu details', 'mpu introduction', 'tell me about university', 'university ke bare mein batao', 'mind power university ke bare mein', 'mpu ke bare mein', 'mpu kya hai', 'university kya hai', 'about college', 'college info', 'university recognition', 'university approval', 'ugc approved university han kya', 'is university approved', 'university background', 'university overview', 'mpu overview', 'mind power university overview'],
    response: {
      displayText: `Mind Power University is approved by the University Grants Commission (UGC) under Section 2(f) and Department Of Higher education Uttrakhand of the UGC Act ${createLink('Learn more about our university', 'https://mindpoweruniversity.ac.in/overview/')} or watch our ${createLink('campus tour video', 'https://www.youtube.com/watch?v=y5_dg6Ytkss')}.`,
      speechText: "Mind Power University is approved by the University Grants Commission (UGC) under Section 2(f) and Department Of Higher education Uttrakhand of the UGC Act. Learn more about our university or watch our campus tour video."
    }
  },

  // Fees
  {
    keywords: ['feee', 'fees', 'fee', 'payment', 'cost', 'fee kitni hai', 'fees kitni hai', 'main hoga'],
    response: {
      displayText: "Please refer to the fee structure below. For exact fees, contact our admissions office at +91 8439512284",
      speechText: "Please refer to the fee structure below. For exact fees, contact our admissions office at 8439512284",
      media: "/assets/fee_structure.jpg",
      isMedia: true
    }
  },

  // Location
  {
    keywords: ['location', 'Location', 'kidhar hai', 'address', 'address', 'where is', 'kha pr hai', 'situated'],
    response: {
      displayText: `Our campus is located in Bohra Kunn, Bheemtaal, Nainital, Uttarakhand. ${createLink('View on map', 'https://www.google.com/maps/place/Mind+Power+University/@29.3281525,79.5530087,17z/data=!3m1!4b1!4m6!3m5!1s0x39a09927f2710b87:0x732b8be692e46e82!8m2!3d29.3281525!4d79.5530087!16s%2Fg%2F11vr4dkw4z?entry=ttu&g_ep=EgoyMDI1MDcwOS4wIKXMDSoASAFQAw%3D%3D')}`,
      speechText: "Our campus is located in the beautiful hills of Uttarakhand, at Bohra Kunn, Bheemtaal, Nainital. It's a peaceful and scenic place perfect for learning. You can also view on map"
    }
  },

  // Contact
  {
    keywords: ['contact', 'email', 'phone', 'phone number', 'number'],
    response: {
      displayText: "Contact us at:<br>Email: info@mindpoweruniversity.ac.in<br>Phone: +91 9212263645 <br>For admissions: +91 8439512284",
      speechText: "Contact us at, info@mindpoweruniversity.ac.in or call us for admissions at: 8439512284"
    }
  },

  // Scholarships
  {
     keywords: ['scholarship', 'scholarships'],
     response: {
      displayText: "We offer scholarships based on your 12th percentage and CUET marks. Please check the scholarship details in the image below. For more information, contact our admissions office at +91 8439512284",
      speechText: "We offer scholarships based on your twelfth percentage and CUET marks. Please check the scholarship details shown.",
      media: "/assets/fee_structure.jpg",
      isMedia: true
    }
  },

  // Hostel
  {
    keywords: ['hostel', 'hostels', 'accommodation', 'stay', 'room', 'residence', 'living'],
    response: {
      displayText: `We provide excellent hostel facilities with:<br>- AC/Non-AC rooms<br>- 24/7 security<br>- WiFi<br>- Mess facility<br>${createLink('Hostel details', 'https://mindpoweruniversity.ac.in/hostel/')}`,
      speechText: "We provide excellent hostel facilities with AC or Non-AC rooms, with security, WiFi, and Mess facility. Hostel details"
    }
  },

  // Flirt Responses
  {
    keywords: ['beautiful', 'cute', 'tum', 'sweet', 'pretty', 'hot', 'tum bahut', 'sexy', 'nice', 'smart', 'lovely', 'attractive', 'love', 'like', 'pyar', 'marry', 'crush', 'flirt', 'shaadi', 'mast', 'pyari', 'acchi', 'bahut sundar', 'sundar', 'maal'],
    response: {
      displayText: "It was lovely talking to you too 😊 Please tell me, how can I assist you with information about Mind Power University?",
      speechText: "It was lovely talking to you too. Please tell me, how can I assist you with information about Mind Power University?"
    }
  },

  // Admissions
  {
    keywords: ['admission', 'apply', 'register', 'registration', 'enroll', 'application', 'join', 'how to get in', 'get admission', 'take admission'],
    response: {
      displayText: `You can apply online at: ${createLink('Admissions Portal', 'https://admissions.mindpoweruniversity.ac.in')}<br>Or contact our admission office at +91 8439512284, +91 8882822265`,
      speechText: "You can directly apply online at our Admissions Portal. Or contact our admission office at 8439512284"
    }
  },


  {
  keywords: [
    // General doubts about university quality
    "should I take admission in mind power university",
    "is mind power university good",
    "mpu acchi university hai kya",
    "mpu kaisi university hai",
    "mind power university kaise hai",
    "college wadya hai kya",
    "university acchi hai kya",
    "should I choose this university",
    "is it good to study at mind power university",
    "mpu admission lena chahiye kya",
    "mind power university ka reputation",
    "university genuine hai kya",
    "college trustworthy hai kya",
    "mpu mein padhe ya nahi",
    "is university worth it",
    "best course in mind power university",
    "kon sa course best hai university ka",
    "which program is best at mind power university",
    "mpu mein best course kaun sa hai",
    "yah college theek han ",
    "acchi hai kya",
    "mpu mein kya padhna chahiye"
  ],
  response: {
    displayText: `Absolutely! Mind Power University isn’t just approved by UGC — it’s powered by ambition. With industry-relevant courses, modern labs, experienced faculty, and a strong focus on placements, students don’t just study here — they grow, explore, and launch real careers. Still confused? ${createLink("Take a virtual tour", "https://www.youtube.com/watch?v=y5_dg6Ytkss")} or call our counselor directly at 📞 8439512284 to get a feel for the campus vibe!`,
    
    speechText: "Absolutely! Mind Power University isn’t just UGC-approved — it’s powered by ambition. With expert faculty, industry-focused courses, modern labs, and strong placements, students here don’t just study — they grow, explore, and build real careers. Still not sure? Take a virtual tour, or directly call our counselor at 8439512284 to get the campus vibe!"
  }
},


  // Leadership
  {
    keywords: ['chancellor', 'pro-chancellor', 'registrar', 'Vice Chancellor'],
    response: (keyword) => {
      const leader = universityLeadership[keyword] || Object.values(universityLeadership)
        .find(l => l.name.toLowerCase().includes(keyword.toLowerCase()));
      if (leader) {
        return {
          displayText: `${leader.position}: ${leader.name}<br>Email: ${leader.email}`,
          speechText: `${leader.position}: ${leader.name}. Email: ${leader.email}`
        };
      }
      return {
        displayText: "I'm sorry, I couldn't find that information right now. Please feel free to contact our admin team at itcell@mindpoweruniversity.ac.in for further help.",
        speechText: "I'm sorry, I couldn't find that information right now. Please feel free to contact our admin team at itcell@mindpoweruniversity.ac.in for further help."
      };
    }
  },

  // ========== UNIVERSITY INFORMATION ADDITIONS ==========
  
  // University Basic Info
  {
    keywords: ['established', 'year of establishment', 'founded', 'started', 'since when'],
    response: {
      displayText: "Mind Power University was established in 2011 and has been providing quality education since then.",
      speechText: "The university was established in 2011."
    }
  },
  {
    keywords: ['approval', 'recognized', 'ugc', 'aicte', 'approvals', 'affiliated', 'recognition'],
    response: {
      displayText: "Mind Power University is approved by UGC under Section 2(f) and 12B of the UGC Act. We are also recognized by the Department of Higher Education, Uttarakhand.",
      speechText: "We are approved by UGC under Section 2(f) and 12B, and recognized by Uttarakhand government."
    }
  },

  // Infrastructure
  {
    keywords: ['lab', 'labs', 'laboratory', 'equipment'],
    response: {
      displayText: `We have state-of-the-art labs including:<br>
      - Computer Labs with latest hardware<br>
      - Science Laboratories<br>
      - Engineering workshop <br>
      - MLT Lab<br>
      - Engineering Workshops`,
      speechText: "We have modern computer, science, Engineering Workshops, management and MLT labs."
    }
  },
  {
    keywords: ['wifi', 'wi fi', 'internet', 'connectivity', 'network'],
    response: {
      displayText: "The entire campus is WiFi enabled with high-speed internet connectivity (100 Mbps leased line).",
      speechText: "Yes, we have campus-wide WiFi with high-speed 100 Mbps internet."
    }
  },
  {
    keywords: ['library', 'books', 'digital library', 'reading'],
    response: {
      displayText: `Our library resources include:<br>
      - 50,000+ books<br>
      - 100+ journals<br>
       - smart library<br>
      - Digital library with 10,000+ e-books<br>
      - Reading rooms with seating for 200 students`,
      speechText: "We have a well-stocked library with physical and digital resources including 50,000 books."
    }
  },

  {
    keywords: ['classroom', 'smart classroom', 'lecture hall', 'teaching facilities'],
    response: {
      displayText: "We have modern classrooms with:<br>- Smart boards<br>- Projectors<br>- Comfortable seating<br>- Air conditioning",
      speechText: "Our classrooms are equipped with smart boards, projectors and comfortable seating."
    }
  },

  // Faculty Information
  {
    keywords: ['faculty', 'teachers', 'professors', 'teacher strength', 'staff'],
    response: {
      displayText: "We have over 100 highly qualified faculty members including:<br>- 30 PhD holders<br>- 15 industry experts<br>- Visiting professors from IITs and foreign universities",
      speechText: "There are over 100 highly qualified faculty members including PhDs and industry experts."
    }
  },

  // Admission Related
  {
    keywords: ['admission date', 'admission schedule', 'last date', 'apply by', 'deadline'],
    response: {
      displayText: `Admission schedule for 2025-2026:<br>
      - Start Date: 1st May 2025<br>
      - Last Date: 30th oct 2025<br>
      - Entrance Tests: May 2025<br>
      ${createLink('Download full schedule', 'https://www.mindpoweruniversity.ac.in/admissions/schedule')}`,
      speechText: "Admissions start on 1st May and end on 30th June 2025, with entrance tests in July."
    }
  },
  {
    keywords: ['cuet', 'common university entrance test', 'entrance exam'],
    response: {
      displayText: "Admission details:<br>- UG Courses: CUET scores accepted<br>- PG Courses: University entrance exam<br>- Diploma: Direct admission based on 12th marks",
      speechText: "We accept CUET for UG courses but have our own exam for PG courses. Diploma admissions are based on 12th marks."
    }
  },
  {
    keywords: ['eligibility', 'criteria', 'requirements', 'qualification'],
    response: {
      displayText: `General eligibility criteria:<br>
      - UG Courses: 10+2 with minimum 50%<br>
      - PG Courses: Graduation with 55%<br>
      - Ph.D: Master's degree with 55%<br>
      ${createLink('See detailed eligibility', 'https://www.mindpoweruniversity.ac.in/admissions/eligibility')}`,
      speechText: "Minimum 50% for UG, 55% for PG and Ph.D courses are required."
    }
  },
  {
    keywords: ['placement', 'jobs', 'career', 'recruitment', 'companies'],
    response: {
      displayText: `Our placement highlights:<br>
      - 80% placement rate<br>
      - Top recruiters: oracle, Wipro, Amazon, IBM ,UnivDatos, and Many more<br>
      - Highest package: 22 LPA<br>
      - Average package: 4.5 LPA<br>
      ${createLink('Placement details', 'https://www.mindpoweruniversity.ac.in/placements')}`,
      speechText: "We have 80% placement rate with top companies like Oracle and IBM visiting campus. Highest package is 22 LPA."
    }
  }
];

// Enhanced courseDatabase with all programs
const courseDatabase = {
  // Management
 management: {
  undergraduate: {
    courses: [
      {
        name: "BBA",
        duration: "3 Years",
        specs: ["Marketing", "Finance", "Human Resources", "Digital Marketing", "Business Analytics"],
        description: "Comprehensive program with internships and live business projects. Includes industry visits and expert guest lectures.",
        keywords: [
          // 1. Official Name Variations
          "bba",
          "bachelor of business administration",
          
          // 2. Common Abbreviations
          "bba course",
          "bba program",
          "BBA course",
          "tell me about the bba course",
          "ug business course",
          
          // 3. Question Formats
          "what is bba course",
          "details of bba degree",
          "about bba program",
          "how is bba course",
          
          // 4. Career-focused
          "business management degree",
          "management career course",
          "bba for marketing",
          "bba finance course",
          
          // 5. Duration Related
          "3 year bba course",
          "bba degree duration",
          
          // 6. Specialization Specific
          "digital marketing bba",
          "bba in hr",
          "bba business analytics",
          
          // 7. Comparison Queries
          "bba vs bcom",
          "which is better bba or mba",
          
          // 8. Hindi Mix
          "bba course kya hota hai",
          "bba ke bare mein batao",
          "bba karke kya ban sakte hain"
        ]
      },
      {
        name: "B.Com",
        duration: "3 Years",
        specs: ["Accounting", "Taxation", "Banking", "Insurance"],
        description: "Commerce degree blending theoretical knowledge with practical accounting skills. Includes CA/CS foundation preparation.",
        keywords: [
          // 1. Official Name Variations
          "bcom",
          "BCOM",
          "bachelor of commerce",
          
          // 2. Common Abbreviations
          "b.com course",
          "bcom ug course",
          "tell me about the b com course",
          "commerce undergraduate program",
          
          // 3. Question Formats
          "what is bcom course",
          "about bcom degree",
          "bcom course details",
          "how is bcom for accounting",
          
          // 4. Career-focused
          
          "bcom for ca cs preparation",
          "taxation course ug",
          
          // 5. Duration Related
          "3 year commerce course",
          "bcom duration",
          
          // 6. Specialization Specific
          "bcom accounting course",
          "bcom banking and insurance",
          
          // 7. Comparison Queries
          "bcom vs bba",
          "bcom or ca which is better",
          
          // 8. Hindi Mix
          "bcom course kya hota hai",
          "bcom karke kya ban sakte hain",
          "bcom course k bare main bato",
          "bcom ke bare mein jankari"
        ]
      },
      {
        name: "BBA in Hospitality & Tourism",
        duration: "3 Years",
        specs: ["Hotel Management", "Travel Tourism", "Event Management"],
        description: "Specialized program for hospitality sector with mandatory industry training each semester.",
        keywords: [
          // 1. Official Name Variations
          "bba in hospitality and tourism",
          "bba hospitality course",
          "BBA",
          "please tell me abot the bba course",
          "bba tourism management",
          
          // 2. Common Abbreviations
          "hospitality tourism bba",
          "bba hotel management",
          
          // 3. Question Formats
          "what is bba in hospitality",
          "about hospitality and tourism bba",
          "details of bba tourism course",
          "how is bba in hotel management",
          
          // 4. Career-focused
          "hospitality management degree",
          "travel and tourism ug program",
          "event management course",
          "bba for hotel industry",
          
          // 5. Duration Related
          "3 year hospitality course",
          "bba hospitality duration",
          
          // 6. Specialization Specific
          "bba event management",
          "bba travel tourism",
          
          // 7. Comparison Queries
          "bba hospitality vs hotel management",
          "best college for bba hospitality",
          
          // 8. Hindi Mix
          "bba hospitality kya hota hai",
          "tourism bba course ke bare mein",
          "bba hotel management details hindi"
        ]
      }
    ]
  },
  postgraduate: {
    courses: [
      {
        name: "MBA",
        duration: "2 Years",
        specs: ["Marketing", "Finance", "HR", "Business Analytics", "Operations", "International Business"],
        description: "Industry-focused leadership program with dual specialization options. Includes summer internship and live projects.",
        keywords: [
          // 1. Official Name Variations
          "mba",
          "MBA",
          "master of business administration",
          
          // 2. Common Abbreviations
          "mba course",
          "MBA degree",
          "MBA speclization",
          "pg business degree",
          "mba pg course",
          
          // 3. Question Formats
          "what is mba program",
          "details of mba course",
          "about mba specialization",
          "how is mba for marketing",
          
          // 4. Career-focused
          "leadership mba program",
          "mba for finance",
          "mba business analytics",
          "mba for hr jobs",
          
          // 5. Duration Related
          "2 year mba course",
          "mba program duration",
          
          // 6. Specialization Specific
          "mba in international business",
          "mba operations course",
          
          
          
          // 8. Hindi Mix
          "mba kya hota hai",
          "mba karne ke fayde",
          "mba ke bare main bato",
          "mba krna chaiye ya nahi",
          "mba course ke bare mein"
        ]
      },
      {
        name: "M.Com",
        duration: "2 Years",
        specs: ["Accounting", "Financial Analysis", "Taxation"],
        description: "Advanced commerce curriculum with research components and industry interface.",
        keywords: [
          // 1. Official Name Variations
          "mcom",
          "M COM",
          "master of commerce",
          
          // 2. Common Abbreviations
          "m com pg course",
          "m com",
          "mcom post graduation",
          
          // 3. Question Formats
          "what is mcom course",
          "mcom details",
          "about mcom degree",
          "how is mcom in accounting",
          
          // 4. Career-focused
          "postgraduate commerce degree",
          "mcom for financial analysis",
          "mcom taxation course",
          "career after mcom",
          
          // 5. Duration Related
          "2 year commerce pg course",
          "mcom program duration",
          
          // 6. Specialization Specific
          "mcom in accounting",
          "mcom in finance",
          
          // 7. Comparison Queries
          "mcom vs mba",
          "mcom or ca",
          
          // 8. Hindi Mix
          "mcom kya hota hai",
          "mcom ke baad kya karein",
          "mcom course hindi mein"
        ]
      }
    ]
  }
},
 
  // Computer Applications
  computer_application: {
  undergraduate: {
    courses: [
      {
        name: "BCA",
        duration: "3 Years",
        specs: ["Software Development", "Web Technologies", "Databases", "Cloud Computing"],
        description: "Programming-centric curriculum with emphasis on full-stack development. Includes certifications in Python and Java.",
        keywords: [
          // 1. Official Name Variations
          "bca",
          "bachelor of computer applications",

          // 2. Common Abbreviations
          "bca course",
          "ug computer application program",
          "bca full stack",

          // 3. Question Formats
          "what is bca course",
          "bca program details",
          "how is bca for programming",
          "about bca degree",

          // 4. Career-focused
          "software developer bca",
          "bca web development course",
          "career after bca",
          "bca with java and python",

          // 5. Duration Related
          "3 year bca course",
          "bca course duration",

          // 6. Specialization Specific
          "bca cloud computing",
          "bca in databases",
          "bca software development",

          // 7. Comparison Queries
          "bca vs btech",
          "bca vs bsc computer science",

          // 8. Hindi Mix
          "bca course kya hota hai",
          "bca ke baad kya karein",
          "bca programming course hindi mein"
        ]
      },
      {
        name: "B.Sc (Computer Science)",
        duration: "3 Years",
        specs: ["Programming", "Data Structures", "Networks", "Algorithms"],
        description: "Science-based computing degree with strong mathematical foundation. Prepares students for research and development roles.",
        keywords: [
          // 1. Official Name Variations
          "bsc computer science",
          "b.sc in computer science",
          "bsc cs",

          // 2. Common Abbreviations
          "bsc cs course",
          "ug computer science program",
          "bsc cs degree",

          // 3. Question Formats
          "what is bsc computer science",
          "about bsc cs course",
          "details of bsc cs program",
          "how is bsc in computer science",

          // 4. Career-focused
          "bsc computer programming course",
          "data structure degree ug",
          "bsc for coding career",
          "research after bsc cs",

          // 5. Duration Related
          "3 year bsc cs course",
          "bsc computer science duration",

          // 6. Specialization Specific
          "bsc in data structures",
          "bsc in algorithms",
          "computer networks ug degree",

          // 7. Comparison Queries
          "bsc cs vs bca",
          "bsc cs vs btech cs",

          // 8. Hindi Mix
          "bsc computer science kya hota hai",
          "bsc cs ke baad kya karein",
          "computer science degree hindi mein"
        ]
      }
    ]
  },
  postgraduate: {
    courses: [
      {
        name: "MCA (Artifical Intelligence & Data Science)",
        duration: "2 Years",
        specs: ["Machine Learning", "Big Data", "Deep Learning", "NLP"],
        description: "Advanced computing with AI & Data Science specialization. Includes IBM certification and capstone projects.",
        keywords: [
          // 1. Official Name Variations
          "mca artificial intelligence and data science",
          "mca ai ds",
          "mca in ai and data science",

          // 2. Common Abbreviations
          "mca ai course",
          "pg ai data science program",
          "mca data science",

          // 3. Question Formats
          "what is mca in ai and data science",
          "details of mca ai ds course",
          "how is mca artificial intelligence course",
          "about mca with data science",

          // 4. Career-focused
          "ai engineer with mca",
          "data scientist mca",
          "mca machine learning course",
          "career after mca ai ds",

          // 5. Duration Related
          "2 year mca ai ds course",
          "mca ai duration",

          // 6. Specialization Specific
          "mca in nlp",
          "big data course mca",
          "mca deep learning specialization",

          // 7. Comparison Queries
          "mca vs msc computer science",
          "mca ai vs mtech ai",

          // 8. Hindi Mix
          "mca ai ds kya hota hai",
          "mca data science ke baad job",
          "mca artificial intelligence hindi mein"
        ]
      },
      {
        name: "M.Sc (Computer Science)",
        duration: "2 Years",
        specs: ["Advanced Algorithms", "Distributed Systems", "Cloud Architecture"],
        description: "Research-oriented program with thesis component. Prepares for both industry and academia.",
        keywords: [
          // 1. Official Name Variations
          "msc computer science",
          "m.sc in computer science",
          "msc cs",

          // 2. Common Abbreviations
          "msc cs pg course",
          "pg computer science degree",
          "msc computing course",

          // 3. Question Formats
          "what is msc computer science",
          "msc cs course details",
          "how is msc in cs",
          "about msc cs program",

          // 4. Career-focused
          "research after msc cs",
          "msc for software engineering",
          "msc in cloud systems",
          "msc for academia",

          // 5. Duration Related
          "2 year msc cs course",
          "msc computer science duration",

          // 6. Specialization Specific
          "msc in distributed systems",
          "msc advanced algorithms",
          "msc cloud architecture",

          // 7. Comparison Queries
          "msc cs vs mca",
          "msc cs vs mtech",

          // 8. Hindi Mix
          "msc computer science kya hota hai",
          "msc cs ke baad kya karein",
          "msc cs course hindi mein"
        ]
      }
    ]
  }
},


  // Engineering
 engineering: {
  diploma: {
    courses: [
      {
        name: "Diploma in Artificial Intelligence & Machine Learning (IBM)",
        duration: "3 Years",
        specs: ["Machine Learning", "Deep Learning", "NLP", "Computer Vision"],
        description: "Industry-aligned program with IBM certified training. Includes hands-on projects and hackathons.",
        keywords: [
          "diploma in ai ml",
          "ai ml diploma course",
          "artificial intelligence diploma",
          "machine learning diploma",
          "ibm ai course diploma",
          "what is diploma in ai",
          "ai ml 3 year course",
          "diploma in computer vision",
          "diploma ai course kya hai"
        ]
      },
      {
        name: "Diploma in Computer Science Engineering",
        duration: "3 Years",
        specs: ["Programming", "Data Structures", "Operating Systems", "Database Management"],
        description: "Foundational engineering course focused on programming, data systems, and real-world applications.",
        keywords: [
          "diploma in computer science",
          "cs diploma",
          "computer engineering diploma",
          "diploma programming course",
          "3 year cs diploma",
          "what is diploma in computer science",
          "data structure diploma",
          "diploma cs course kya hai"
        ]
      },
      {
        name: "Diploma in Cyber Security & Forensic Science",
        duration: "3 Years",
        specs: ["Ethical Hacking", "Network Security", "Digital Forensics", "Cyber Laws"],
        description: "Comprehensive cybersecurity training with practical labs and certification prep.",
        keywords: [
          "cyber security diploma",
          "diploma in forensic science",
          "ethical hacking course diploma",
          "network security diploma",
          "digital forensics diploma",
          "what is cyber security diploma",
          "cyber diploma kya hota hai"
        ]
      },
      {
        name: "Diploma in Aerospace Engineering with Drone Technology",
        duration: "3 Years",
        specs: ["Aerodynamics", "Unmanned Aerial Vehicles", "Propulsion Systems", "Flight Simulation"],
        description: "Learn aerospace fundamentals with a focus on modern drone applications and UAV systems.",
        keywords: [
          "aerospace diploma",
          "diploma in drone technology",
          "uav course diploma",
          "aerospace engineering diploma",
          "what is aerospace diploma",
          "drone engineering diploma",
          "diploma drone course kya hai"
        ]
      },
      {
        name: "Diploma in Data Science & Cloud Computing",
        duration: "3 Years",
        specs: ["Data Analytics", "Big Data", "Cloud Platforms (AWS/Azure)", "Python"],
        description: "Blend of data science and cloud technologies to build smart, scalable solutions.",
        keywords: [
          "data science diploma",
          "cloud computing diploma",
          "aws diploma course",
          "diploma in python and data",
          "what is diploma in data science",
          "cloud diploma kya hai"
        ]
      },
      {
        name: "Diploma in Mechanical Engineering",
        duration: "3 Years",
        specs: ["Thermodynamics", "Fluid Mechanics", "CAD/CAM", "Manufacturing Processes"],
        description: "Core mechanical concepts with industrial exposure and practical project-based learning.",
        keywords: [
          "mechanical engineering diploma",
          "diploma in cad cam",
          "diploma in fluid mechanics",
          "mechanical diploma course",
          "what is mechanical diploma",
          "3 year mechanical course",
          "mechanical diploma kya hota hai"
        ]
      },
      {
        name: "Diploma in Electronics & Communication Engineering",
        duration: "3 Years",
        specs: ["Analog & Digital Electronics", "Embedded Systems", "Signal Processing", "IoT"],
        description: "Industry-relevant electronics training with modern communication technologies.",
        keywords: [
          "electronics communication diploma",
          "ece diploma course",
          "diploma in iot",
          "diploma embedded systems",
          "electronics diploma kya hota hai",
          "ece 3 year diploma"
        ]
      },
      {
        name: "Diploma in Mechanical Engineering – EV",
        duration: "3 Years",
        specs: ["Electric Vehicles", "Battery Technology", "Power Electronics", "Vehicle Dynamics"],
        description: "Specialized diploma focusing on electric mobility and sustainable vehicle technologies.",
        keywords: [
          "ev mechanical diploma",
          "electric vehicle diploma",
          "battery technology course",
          "ev engineering diploma",
          "diploma in electric vehicles",
          "ev diploma kya hai"
        ]
      }
    ]
  },
  undergraduate: {
    courses: [
      {
        name: "B.Tech (A I & M L - IBM)",
        duration: "4 Years",
        specs: ["Neural Networks", "Computer Vision", "Robotics", "IoT"],
        description: "Engineering degree built in partnership with IBM Certification. Includes semester long industry projects and internship.",
        keywords: [
          "btech ai ml",
          "btech in artificial intelligence and machine learning",
          "btech aiml",
          "BTech aiml",
          "ai ml engineering",
          "ai ml btech",
          "aiml course",
          "what is btech in ai ml",
          "about btech ai ml program",
          "tell me about aiml course",
          "how is the ai ml course",
          "ai ml engineering degree",
          "ai engineer course",
          "machine learning degree",
          "become ai engineer",
          "ibm ai course",
          "btech with ibm",
          "ai ml program with ibm",
          "4 year ai course",
          "ai ml degree duration",
          "neural networks degree",
          "computer vision engineering",
          "iot engineering course",
          "best ai ml engineering college",
          "ai ml vs computer science",
          "ai ml engineering course kaisa hai",
          "btech ai ml ke bare mein batao",
          "aiml course available hai kya",
          "aiml",
          "AI ML",
          "IBM Course",
          "ai ml mein degree"
        ]
      },
      {
        name: "B.Tech (Computer Science Engineering)",
        duration: "4 Years",
        specs: ["AI", "Cloud Computing", "Cyber Security", "Blockchain"],
        description: "Core CS engineering with modern specializations. Includes GATE preparation support.",
        keywords: [
          "computer science engineering",
          "btech cse",
          "about btech computer science",
          "cs engineering program",
          "btech in cs",
          "cs engineering course",
          "what is btech cse",
          "cse engineering degree",
          "cloud computing cse",
          "cyber security in cse"
        ]
      },
      {
        name: "B.Tech (Cyber Security & Forensic Science)",
        duration: "4 Years",
        specs: ["Network Security", "Ethical Hacking", "Cyber Forensics", "Penetration Testing"],
        description: "Focused on digital security and forensic investigation with industry-relevant training.",
        keywords: [
          "cyber security btech",
          "btech in forensic science",
          "ethical hacking btech",
          "digital forensics degree",
          "cyber engineering course",
          "btech cyber forensics",
          "what is btech in cyber security"
        ]
      },
      {
        name: "B.Tech (Aerospace Engineering with Drone Technology)",
        duration: "4 Years",
        specs: ["Aerodynamics", "Drone Design", "Propulsion Systems", "Flight Control Systems"],
        description: "Combines aerospace fundamentals with drone technologies and UAV system design.",
        keywords: [
          "btech aerospace engineering",
          "drone engineering course",
          "btech in drone technology",
          "aerospace drone degree",
          "what is aerospace engineering",
          "btech aerospace with uav"
        ]
      },
      {
        name: "B.Tech (Data Science & Cloud Computing)",
        duration: "4 Years",
        specs: ["Data Analytics", "Cloud Architecture", "Big Data", "Python & R"],
        description: "Integrates data-driven decision making with scalable cloud platforms like AWS and Azure.",
        keywords: [
          "btech data science",
          "cloud computing engineering",
          "data analytics btech",
          "aws course btech",
          "what is btech in data science",
          "big data engineering degree"
        ]
      },
      {
        name: "B.Tech (Mechanical Engineering)",
        duration: "4 Years",
        specs: ["Fluid Mechanics", "Machine Design", "CAD/CAM", "Industrial Engineering"],
        description: "Traditional mechanical concepts with hands-on experience in industrial tools and simulations.",
        keywords: [
          "mechanical engineering btech",
          "btech in mechanical",
          "mechanical design degree",
          "industrial engineering course",
          "cad cam btech",
          "what is mechanical engineering"
        ]
      },
      {
        name: "B.Tech (Electronics & Communication Engineering)",
        duration: "4 Years",
        specs: ["Microcontrollers", "Digital Communication", "VLSI", "Embedded Systems"],
        description: "Modern ECE program with a focus on embedded technology and communication systems.",
        keywords: [
          "electronics communication btech",
          "ece engineering",
          "btech in ece",
          "vlsi btech course",
          "embedded systems engineering",
          "what is ece course"
        ]
      },
      {
        name: "B.Tech (Mechanical Engineering – EV)",
        duration: "4 Years",
        specs: ["Electric Powertrains", "Battery Management Systems", "EV Design", "Renewable Energy"],
        description: "Specialized in electric vehicles with a focus on sustainable automotive engineering.",
        keywords: [
          "btech in ev",
          "electric vehicle engineering",
          "battery tech engineering",
          "mechanical ev course",
          "sustainable vehicle degree",
          "ev btech kya hai"
        ]
      }
    ]
  },
  postgraduate: {
    courses: [
      {
        name: "M.Tech (Computer Science)",
        duration: "2 Years",
        specs: ["Advanced Algorithms", "Distributed Systems", "AI", "Quantum Computing"],
        description: "Research-driven master's program with thesis requirement. Strong industry collaboration.",
        keywords: [
          "mtech computer science",
          "mtech in cs",
          "pg in computer science",
          "quantum computing mtech",
          "mtech cs kya hai",
          "cs engineering postgraduation"
        ]
      },
      {
        name: "M.Tech (Data Science)",
        duration: "2 Years",
        specs: ["Predictive Analytics", "Deep Learning", "Data Visualization"],
        description: "Advanced data science training with real-world case studies and capstone project.",
        keywords: [
          "mtech data science",
          "pg in data analytics",
          "deep learning mtech",
          "predictive analytics course",
          "data science mtech kya hai",
          "postgraduate in data science"
        ]
      }
    ]
  }
},


  // Pharmacy
pharmacy: {
  undergraduate: {
    courses: [
      {
        name: "B.Pharmacy",
        duration: "4 Years",
        specs: ["Pharmaceutics", "Pharmacology", "Pharmacognosy"],
        description: "Professional pharmacy degree covering drug development, formulation and quality control.",
        keywords: [
          "b pharmacy",
          "bachelor of pharmacy",
          "b.pharma course",
          "pharmacy degree",
          "4 year pharmacy course",
          "what is b pharmacy",
          "about b.pharma program",
          "pharmaceutics degree",
          "pharmacology course",
          "pharmacy undergraduate degree",
          "b pharmacy ke baare mein",
          "pharmacy field kya hai",
          "career in pharmacy",
          "pharmacy course kaisa hai"
        ]
      }
    ]
  },
  diploma: {
    courses: [
      {
        name: "D.Pharmacy",
        duration: "2 Years",
        specs: ["Pharmacy Practice", "Hospital Pharmacy", "Drug Store Management"],
        description: "Practical training for roles in pharmacies, hospitals and healthcare institutions.",
        keywords: [
          "d pharmacy",
          "diploma in pharmacy",
          "d pharma course",
          "2 year pharmacy diploma",
          "what is d pharmacy",
          "pharmacy assistant course",
          "hospital pharmacy training",
          "drug store management course",
          "pharmacy diploma ke baare mein",
          "d pharma course details",
          "d pharma kya hota hai"
        ]
      }
    ]
  }
},


  // Hospitality
 hospitality: {
  undergraduate: {
    courses: [
      {
        name: "BHM (Bachelor of Hotel Management)",
        duration: "3 Years",
        specs: ["Front Office", "Housekeeping", "Food Production", "Food Service"],
        description: "Comprehensive hotel operations training with mandatory industry internships each year.",
        keywords: [
          // 1. Official Name Variations
          "bhm",
          "bachelor of hotel management",
          "bhm hotel management course",
          
          // 2. Common Abbreviations
          "bhm degree",
          "hotel mgmt course",
          "bhm hotel course",
          
          // 3. Question Formats
          "what is bhm course",
          "about bachelor of hotel management",
          "details of bhm program",
          "how is bhm course",
          
          // 4. Career-focused
          "hotel management career",
          "become hotel manager",
          "hospitality management job",
          "hotel industry training program",
          
          // 5. Practical Elements
          "bhm internship program",
          "hotel management with training",
          
          // 6. Duration Related
          "3 year hotel management course",
          "bhm duration",
          
          // 7. Specialization Specific
          "front office training",
          "food production course",
          "housekeeping management",
          
          // 8. Comparison Queries
          "bhm vs bsc hotel management",
          "best bhm college in india",
          
          // 9. Hindi Mix
          "bhm course kya hai",
          "bhm course ke baare mein",
          "hotel management mein degree"
        ]
      },
      {
        name: "B.Sc (Hotel Management)",
        duration: "3 Years",
        specs: ["Hospitality Operations", "Event Management", "Food & Beverage Service", "Hospitality Marketing"],
        description: "Academic and practical foundation in hotel management with a focus on global hospitality standards.",
        keywords: [
          // 1. Official Name Variations
          "bsc hotel management",
          "bachelor of science in hotel management",
          "b.sc in hospitality",
          
          // 2. Common Abbreviations
          "bsc hm",
          "hotel management bsc",
          "bsc hospitality course",
          
          // 3. Question Formats
          "what is bsc hotel management",
          "about bsc in hospitality",
          "details of bsc hotel course",
          "how is bsc hotel management",
          
          // 4. Career-focused
          "hospitality operations course",
          "event management career",
          "food and beverage service degree",
          "hospitality marketing jobs",
          
          // 5. Practical Elements
          "bsc with hotel internship",
          "practical hotel training bsc",
          
          // 6. Duration Related
          "3 year bsc hotel management",
          "bsc hm course duration",
          
          // 7. Specialization Specific
          "event management specialization",
          "hospitality operations training",
          
          // 8. Comparison Queries
          "bsc hotel vs bhm",
          "best bsc hotel college",
          
          // 9. Hindi Mix
          "bsc hotel course kya hai",
          "bsc hospitality ke baare mein",
          "hotel management bsc mein kya hota hai"
        ]
      }
    ]
  },
  diploma: {
    courses: [
      {
        name: "DHM (Diploma in Hotel Management)",
        duration: "3 Years",
        specs: ["Culinary Arts", "Beverage Management", "Accommodation Operations"],
        description: "Hands-on training in core hospitality functions with international standards.",
        keywords: [
          // 1. Official Name Variations
          "diploma in hotel management",
          "dhm course",
          "dhm hotel diploma",
          
          // 2. Common Abbreviations
          "dhm",
          "hotel diploma",
          "diploma hospitality course",
          
          // 3. Question Formats
          "what is dhm course",
          "about diploma in hotel management",
          "dhm course details",
          "how is dhm course",
          
          // 4. Career-focused
          "culinary arts diploma",
          "become hotel chef",
          "accommodation manager course",
          "hospitality diploma jobs",
          
          // 5. Practical Elements
          "dhm practical training",
          "hands-on hotel diploma",
          
          // 6. Duration Related
          "3 year diploma hotel management",
          "dhm course duration",
          
          // 7. Specialization Specific
          "culinary course",
          "beverage management training",
          "accommodation operations diploma",
          
          // 8. Comparison Queries
          "dhm vs bhm",
          "best dhm college",
          
          // 9. Hindi Mix
          "dhm course kya hai",
          "dhm ke baare mein batao",
          "hotel management diploma kya hota hai"
        ]
      }
    ]
  }
},


  // Journalism & Mass Media
  journalism: {
    undergraduate: {
      courses: [
        {
          name: "BJMC (Journalism)",
          duration: "3 Years",
          specs: ["Print Media", "Electronic Media", "Digital Journalism", "PR"],
          description: "Media production-focused program with studio training and industry projects."
        }
      ]
    },
    postgraduate: {
      courses: [
        {
          name: "MJMC (Mass Communication)",
          duration: "2 Years",
          specs: ["Media Research", "Corporate Communication", "Broadcast Journalism"],
          description: "Advanced media studies with specialization options and dissertation requirement."
        }
      ]
    }
  },

  // Vocational (UG/PG)
 vocational: {
  undergraduate: {
    courses: [
      {
        name: "B.Voc Medical Lab Technology",
        duration: "3 Years",
        specs: ["Pathology", "Microbiology", "Biochemistry"],
        description: "Hands-on lab technology training with hospital rotations and certification.",
        keywords: [
          // 1. Official Name Variations
          "b.voc medical lab technology",
          "b voc mlt",
          "bachelor of vocation in medical lab tech",
          
          // 2. Common Abbreviations
          "b voc mlt course",
          "vocational mlt program",
          "mlt b.voc",
          
          // 3. Question Formats
          "what is b.voc mlt",
          "about b voc medical lab technology",
          "details of b voc mlt program",
          "how is mlt course",
          
          // 4. Career-focused
          "lab technician degree",
          "career in medical lab technology",
          "become lab technologist",
          "hospital lab course",
          
          // 5. Practical Elements
          "mlt with hospital training",
          "pathology and microbiology course",
          
          // 6. Duration Related
          "3 year mlt course",
          "b voc mlt duration",
          
          // 7. Specialization Specific
          "biochemistry lab course",
          "microbiology training program",
          
          // 8. Comparison Queries
          "b voc vs bsc mlt",
          "best mlt vocational course",
          
          // 9. Hindi Mix
          "b voc mlt course kya hai",
          "mlt vocational course ke baare mein",
          "lab technician kaise bane"
        ]
      },
      {
        name: "B.Voc Radiology & Imaging",
        duration: "3 Years",
        specs: ["Radiography", "Sonography", "CT/MRI Technology"],
        description: "Skill-based program for diagnostic imaging roles with practical training.",
        keywords: [
          // 1. Official Name Variations
          "b voc radiology and imaging",
          "b voc in radiography",
          "b.voc medical imaging",
          
          // 2. Common Abbreviations
          "radiology b voc",
          "imaging technology course",
          "b voc radiology course",
          
          // 3. Question Formats
          "what is b voc in radiology",
          "about b voc imaging program",
          "radiology and imaging course details",
          "how is radiology b voc",
          
          // 4. Career-focused
          "diagnostic imaging course",
          "career in radiology",
          "radiographer degree",
          "ct mri technician program",
          
          // 5. Practical Elements
          "radiology with practical training",
          "sonography and mri course",
          
          // 6. Duration Related
          "3 year radiology course",
          "b voc radiology duration",
          
          // 7. Specialization Specific
          "ct scan technician course",
          "sonography training vocational",
          
          // 8. Comparison Queries
          "b voc vs bsc radiology",
          "best radiology vocational course",
          
          // 9. Hindi Mix
          "b voc radiology kya hai",
          "radiology course ke baare mein",
          "imaging technician kaise bane"
        ]
      },
      {
        name: "B.Voc Hospital Management",
        duration: "3 Years",
        specs: ["Healthcare Administration", "Medical Records", "Patient Care"],
        description: "Operational training for hospital administration and healthcare management.",
        keywords: [
          // 1. Official Name Variations
          "b voc hospital management",
          "b.voc in healthcare admin",
          "bachelor of vocation hospital admin",
          
          // 2. Common Abbreviations
          "hospital management b voc",
          "vocational hospital admin course",
          "b voc hm course",
          
          // 3. Question Formats
          "what is b voc hospital management",
          "about hospital management vocational course",
          "hospital admin course details",
          "how is hospital management b voc",
          
          // 4. Career-focused
          "career in hospital administration",
          "healthcare manager course",
          "hospital operations degree",
          "patient care training program",
          
          // 5. Practical Elements
          "hospital training vocational",
          "medical records admin course",
          
          // 6. Duration Related
          "3 year hospital management course",
          "b voc hospital course duration",
          
          // 7. Specialization Specific
          "healthcare records training",
          "hospital operations training",
          
          // 8. Comparison Queries
          "b voc vs mba hospital management",
          "best hospital management vocational course",
          
          // 9. Hindi Mix
          "b voc hospital management kya hai",
          "hospital management course ke baare mein",
          "hospital mein job kaise milegi"
        ]
      }
    ]
  },
  postgraduate: {
    courses: [
      {
        name: "M.Voc Medical Lab Technology",
        duration: "2 Years",
        specs: ["Advanced Pathology", "Molecular Diagnostics", "Lab Management"],
        description: "Specialized training for supervisory roles in medical laboratories.",
        keywords: [
          // 1. Official Name Variations
          "m voc medical lab technology",
          "mvoc in mlt",
          "masters in medical lab tech",
          
          // 2. Common Abbreviations
          "m voc mlt course",
          "mvoc lab technology",
          "mlt vocational master's program",
          
          // 3. Question Formats
          "what is m voc mlt",
          "mvoc lab tech course details",
          "about m voc in mlt",
          "how is mvoc medical lab tech",
          
          // 4. Career-focused
          "lab supervisor course",
          "advanced medical lab training",
          "become senior lab technologist",
          "molecular diagnostics training",
          
          // 5. Practical Elements
          "lab management program",
          "pathology training masters level",
          
          // 6. Duration Related
          "2 year mvoc mlt course",
          "m voc medical lab duration",
          
          // 7. Specialization Specific
          "molecular diagnostics course",
          "lab management training",
          
          // 8. Comparison Queries
          "mvoc vs msc mlt",
          "best mvoc lab course",
          
          // 9. Hindi Mix
          "m voc mlt kya hai",
          "mvoc medical lab course ke baare mein",
          "medical lab supervisor kaise bane"
        ]
      },
      {
        name: "PG Diploma in Health Management",
        duration: "1 Year",
        specs: ["Hospital Operations", "Health Informatics", "Quality Assurance"],
        description: "Intensive training for healthcare administration professionals.",
        keywords: [
          // 1. Official Name Variations
          "pg diploma in health management",
          "post graduate health admin course",
          "pg health care management",
          
          // 2. Common Abbreviations
          "pgd health management",
          "pg diploma healthcare",
          "health admin pg diploma",
          
          // 3. Question Formats
          "what is pg diploma in health management",
          "pg healthcare course details",
          "about pg diploma in hospital admin",
          "how is health management pg diploma",
          
          // 4. Career-focused
          "hospital operations training",
          "healthcare administration job course",
          "career in health informatics",
          "quality control in healthcare",
          
          // 5. Practical Elements
          "pg diploma hospital practicals",
          "healthcare quality assurance program",
          
          // 6. Duration Related
          "1 year health management course",
          "pg diploma duration in health",
          
          // 7. Specialization Specific
          "hospital operations management",
          "health informatics training",
          
          // 8. Comparison Queries
          "pg diploma vs mba healthcare",
          "best pg diploma in health admin",
          
          // 9. Hindi Mix
          "pg diploma health management kya hai",
          "health management pg course ke baare mein",
          "hospital admin pg diploma kaise kare"
        ]
      }
    ]
  }
},


  // Ph.D. Programs
 phd: {
  doctoral: {
    courses: [
      {
        name: "Ph.D. (Full-time)",
        duration: "3-6 Years",
        specs: ["All Disciplines"],
        description: "Research program with coursework requirement. Includes publication targets and teaching experience.",
        keywords: [
          // 1. Official Name Variations
          "tell me about the phd program",
          "PHD",
          "phd",
          "about the phd",
          "doctoral program",
          "research",
          "full time phd program",
          "full time doctorate",
          "full time research program",
          
          // 2. Common Abbreviations
          "phd course",
          "full time phd",
          "phd course fee",
          
          // 3. Question Formats
          "what is full time phd",
          "about phd full time program",
          "full time phd course details",
          "full time phd program",
          
          // 4. Career-focused
          "career after phd",
          "become professor",
          "research scientist course",
          "doctoral research in india",
          
          // 5. Practical Elements
          "phd with publication",
          "research with teaching experience",
          
          // 6. Duration Related
          "phd 3 to 6 years",
          "phd full time duration",
          
          // 7. Specialization Specific
          "phd in any discipline",
          "research in management science arts",
          
          // 8. Comparison Queries
          "phd full time vs part time",
          "best full time phd programs",
          
          // 9. Hindi Mix
          " full time phd kaise kare",
          "phd research program ke baare mein",
          "full time doctorate kaise kare"
        ]
      },
      {
        name: "Ph.D. (Part-time)",
        duration: "4-7 Years",
        specs: ["All Disciplines"],
        description: "Flexible research program for working professionals with weekend classes.",
        keywords: [
          // 1. Official Name Variations
          "phd part time",
          "part time phd program",
          "part time doctorate",
          "working professional phd",
          
          // 2. Common Abbreviations
          "ph.d. part time",
          "pt phd",
          "phd pt course",
          
          // 3. Question Formats
          "what is part time phd",
          "about phd part time program",
          "phd part time course details",
          "how is phd part time",
          
          // 4. Career-focused
          "phd for working professionals",
          "research while working",
          "doctoral study part time",
          "flexible phd in india",
          
          // 5. Practical Elements
          "phd weekend classes",
          "phd with job",
          
          // 6. Duration Related
          "phd 4 to 7 years",
          "phd part time duration",
          
          // 7. Specialization Specific
          "phd in any field",
          "research in arts science commerce",
          
          // 8. Comparison Queries
          "part time vs full time phd",
          "best part time phd programs",
          
          // 9. Hindi Mix
          "phd part time kya hota hai",
          "phd working professionals ke liye",
          "part time doctorate kaise kare"
        ]
      }
    ]
  }
}

};

const normalizeText = (text) => {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]/g, '') // Remove all non-alphanumeric characters
    .trim();
};

// New function to find best matching keyword from input
const findBestKeywordMatch = (input, keywords) => {
  const inputWords = input.toLowerCase().split(/\s+/);
  let bestMatch = null;
  let bestMatchLength = 0;

  // First check for exact multi-word matches
  for (const keyword of keywords) {
    const keywordWords = keyword.toLowerCase().split(/\s+/);
    if (keywordWords.length > 1 && input.toLowerCase().includes(keyword.toLowerCase())) {
      if (keywordWords.length > bestMatchLength) {
        bestMatch = keyword;
        bestMatchLength = keywordWords.length;
      }
    }
  }

  // If no multi-word match found, check for single word matches
  if (!bestMatch) {
    for (const keyword of keywords) {
      if (keyword.split(/\s+/).length === 1 && 
          inputWords.some(word => word === keyword.toLowerCase())) {
        bestMatch = keyword;
        break;
      }
    }
  }

  return bestMatch;
};

const getCourseDetails = (input) => {
  const normalizedInput = normalizeText(input);

  // First try exact course name match
  for (const category in courseDatabase) {
    for (const level in courseDatabase[category]) {
      const course = courseDatabase[category][level].courses.find(c => 
        normalizeText(c.name) === normalizedInput ||
        (c.keywords && c.keywords.some(kw => normalizeText(kw) === normalizedInput)) // Check keywords
      );
      if (course) return { ...course, category, level };
    }
  }

  // Then try partial match (including keywords)
  for (const category in courseDatabase) {
    for (const level in courseDatabase[category]) {
      const course = courseDatabase[category][level].courses.find(c => 
        normalizeText(c.name).includes(normalizedInput) || 
        normalizedInput.includes(normalizeText(c.name)) ||
        (c.keywords && c.keywords.some(kw => 
          normalizeText(kw).includes(normalizedInput) || 
          normalizedInput.includes(normalizeText(kw))
        ))
      );
      if (course) return { ...course, category, level };
    }
  }
  return null;
};

const handleLeadershipQuery = (input) => {
  for (const [position, data] of Object.entries(universityLeadership)) {
    if (input.includes(position)) {
      return {
        displayText: `${data.position}: ${data.name}<br>Email: ${data.email}`,
        speechText: `${data.position}: ${data.name}. Email: ${data.email}`
      };
    }
  }
  
  for (const leader of Object.values(universityLeadership)) {
    if (input.includes(leader.name.toLowerCase())) {
      return {
        displayText: `${leader.position}: ${leader.name}<br>Email: ${leader.email}`,
        speechText: `${leader.position}: ${leader.name}. Email: ${leader.email}`
      };
    }
  }
  
  return null;
};

const getCategoryFromQuery = (input) => {
  const normalizedInput = normalizeText(input);
  
  for (const [keyword, category] of Object.entries(courseCategoriesMap)) {
    if (normalizedInput.includes(normalizeText(keyword))) {
      return category;
    }
  }
  return null;
};

const getLevelFromQuery = (input) => {
  const normalizedInput = normalizeText(input);
  
  for (const [keyword, level] of Object.entries(courseLevelMap)) {
    if (normalizedInput.includes(normalizeText(keyword))) {
      return level;
    }
  }
  return null;
};

const handleCourseQuery = (input) => {
  const normalizedInput = normalizeText(input);
  
  // Check if query is asking about specializations
  if (/(specialization|specialisations|speciality|specs|subject|area|field)/.test(normalizedInput)) {
    const category = getCategoryFromQuery(input);
    const level = getLevelFromQuery(input);
    
    if (category && level && courseDatabase[category][level]) {
      const courses = courseDatabase[category][level].courses;
      let specs = [];
      
      courses.forEach(course => {
        specs = specs.concat(course.specs);
      });
      
      // Remove duplicates
      specs = [...new Set(specs)];
      
      if (specs.length > 0) {
        return {
          displayText: `Available specializations in ${category.replace('_', ' ')} (${level}):<br>${specs.join(', ')}`,
          speechText: `Available specializations include ${specs.join(', ')}`
        };
      }
    }
  }
  
  // Check if query is about available courses
  if (/(available|offer|have|what|which|list|detail)/.test(normalizedInput)) {
    const category = getCategoryFromQuery(input);
    const level = getLevelFromQuery(input);
    
    if (category && courseDatabase[category]) {
      let responseText = '';
      let speechText = '';
      
      if (level) {
        // Specific level requested
        const courses = courseDatabase[category][level].courses;
        responseText = `Available ${level} programs in ${category.replace('_', ' ')}:<br>`;
        responseText += courses.map(c => c.name).join('<br>');
        
        speechText = `Available ${level} programs include ${courses.map(c => c.name).join(', ')}`;
      } else {
        // All levels for category
        responseText = `We offer these programs in ${category.replace('_', ' ')}:<br><br>`;
        speechText = `We offer these programs in ${category.replace('_', ' ')}: `;
        
        for (const level in courseDatabase[category]) {
          responseText += `<strong>${level.toUpperCase()}:</strong><br>`;
          speechText += `${level}: `;
          
          const courses = courseDatabase[category][level].courses.map(c => c.name);
          responseText += courses.join(', ') + '<br><br>';
          speechText += courses.join(', ') + '. ';
        }
      }
      
      return {
        displayText: responseText,
        speechText: speechText
      };
    }
  }
  
  return null;
};

export const getResponse = (input, lang = 'en') => {
  const cleanedInput = input.replace(/[^\w\s]/gi, ' ').replace(/\s+/g, ' ').trim();
  const lowerInput = cleanedInput.toLowerCase();

  // Handle complex/long queries
  if (cleanedInput.split(' ').length > 15) {
    return {
      displayText: `For detailed information, please visit ${createLink('our website', 'https://www.mindpoweruniversity.ac.in')} or call +91 9717901903 for assistance.`,
      speechText: "For detailed information, please visit our website or call +91 9717901903 for assistance."
    };
  }

  // Handle leadership queries
  const leadershipResponse = handleLeadershipQuery(lowerInput);
  if (leadershipResponse) return leadershipResponse;

  // Handle fee queries
  if (/(fee|fees|payment|cost)/.test(lowerInput)) {
    conversationContext.lastQueryWasFee = true;
    return knowledgeBase.find(item => item.keywords.includes('fee')).response;
  } else {
    conversationContext.lastQueryWasFee = false;
  }

  // NEW: Prioritize exact multi-word matches first
  for (const item of knowledgeBase) {
    // Check for exact multi-word matches first
    const multiWordKeywords = item.keywords.filter(k => k.includes(' '));
    const exactMultiWordMatch = multiWordKeywords.find(k => 
      lowerInput.includes(k.toLowerCase())
    );
    
    if (exactMultiWordMatch) {
      if (typeof item.response === 'function') {
        return item.response(exactMultiWordMatch);
      }
      return item.response;
    }
  }

  // Handle direct course queries (specializations, availability, etc.)
  const courseQueryResponse = handleCourseQuery(cleanedInput);
  if (courseQueryResponse) {
    return courseQueryResponse;
  }

  // Direct Course Match - always check this early
  const directCourseMatch = getCourseDetails(cleanedInput);
  if (directCourseMatch) {
    conversationContext = { currentFlow: null, collectedData: {} };
    return {
      displayText: `<strong>${directCourseMatch.name}</strong><br>Duration: ${directCourseMatch.duration}<br>` +
        `Specializations: ${directCourseMatch.specs.join(', ')}<br>` +
        `Description: ${directCourseMatch.description}<br>` +
        `Contact: admissions@mindpoweruniversity.ac.in or +91 8439512284`,
      speechText: `${directCourseMatch.name}. Duration: ${directCourseMatch.duration}. ` +
        `Specializations: ${directCourseMatch.specs.join(', ')}. ` +
        `Description: ${directCourseMatch.description}. ` +
        `Contact: admissions@mindpoweruniversity.ac.in or 8439512284`
    };
  }

  // Then check for single word matches
  for (const item of knowledgeBase) {
    const singleWordKeywords = item.keywords.filter(k => !k.includes(' '));
    const singleWordMatch = singleWordKeywords.find(k => {
      const regex = new RegExp(`\\b${k.toLowerCase()}\\b`);
      return regex.test(lowerInput);
    });

    if (singleWordMatch) {
      if (typeof item.response === 'function') {
        return item.response(singleWordMatch);
      }
      return item.response;
    }
  }

  // Course inquiry flow
  const courseKeywords = [
    "course", "courses", "program", "programs", "degree", "degrees",
    "kaun kaun se subject milte han", "course list", "padhai ke options"
  ];

  if (
    courseKeywords.some(keyword => lowerInput.includes(keyword)) ||
    conversationContext.currentFlow === FLOWS.COURSE_INQUIRY
  ) {
    conversationContext.currentFlow = FLOWS.COURSE_INQUIRY;

    if (!conversationContext.collectedData.category) {
      const categories = Object.keys(courseDatabase);
      const categoryMatch = categories.find(cat => lowerInput.includes(cat));
      if (categoryMatch) {
        conversationContext.collectedData.category = categoryMatch;
      } else {
        
        const spokenCategories = categories.map(cat => cat.replace(/_/g, ' ')).join(', ');
return {
  displayText: `We offer courses in: ${categories.join(', ')}. Which field interests you?`, // Keeps underscores in display
  speechText: `We offer courses in ${spokenCategories}. Which field interests you?` // Removes underscores in speech
};
      }
    }

    if (!conversationContext.collectedData.level) {
      const levels = ['undergraduate', 'postgraduate', 'doctoral'];
      const levelMatch = levels.find(lvl => lowerInput.includes(lvl));
      if (levelMatch) {
        conversationContext.collectedData.level = levelMatch;
      } else {
        return {
          displayText: `Available levels: ${levels.join(', ')}. Which level?`,
          speechText: `Available levels: ${levels.join(', ')}. Which level?`
        };
      }
    }

    const { category, level } = conversationContext.collectedData;
    const courses = courseDatabase[category][level].courses;
    const courseMatch = courses.find(c => lowerInput.includes(c.name.toLowerCase()));

    if (courseMatch) {
      conversationContext = { currentFlow: null, collectedData: {} };
      return {
        displayText: `${courseMatch.name}<br>Duration: ${courseMatch.duration}<br>` +
          `Specializations: ${courseMatch.specs.join(', ')}<br>` +
          `Description: ${courseMatch.description}<br>` +
          `Contact: admissions@mindpoweruniversity.ac.in or +91 8439512284`,
        speechText: `${courseMatch.name}. Duration: ${courseMatch.duration}. ` +
          `Specializations: ${courseMatch.specs.join(', ')}. ` +
          `Description: ${courseMatch.description}. ` +
          `Contact: admissions@mindpoweruniversity.ac.in or +91 8439512284`
      };
    } else {
      return {
        displayText: `Available courses:<br>${courses.map(c => c.name).join('<br>')}<br>Which one?`,
        speechText: `Available courses: ${courses.map(c => c.name).join(', ')}. Which one?`
      };
    }
  }

  return {
    displayText: `I couldn't understand your query. For more information, please visit ${createLink('our website', 'https://www.mindpoweruniversity.ac.in')} or call +91 8439512284.`,
    speechText: "I couldn't understand your query. For more information, please visit our website or call at 8439512284."
  };
};

// yha 

// Formatter Function (keep this unchanged)
export const formatResponse = (response) => {
  if (!response) {
    return {
      displayText: "Sorry, I couldn't process that request.",
      speechText: "Sorry, I couldn't process that request."
    };
  }

  if (typeof response === 'object' && response.displayText !== undefined) {
    return response;
  }

  if (typeof response === 'object' && response.text !== undefined) {
    return {
      displayText: response.text,
      speechText: getSpeechText(response.text),
      ...(response.media && { media: response.media }),
      ...(response.isMedia && { isMedia: response.isMedia })
    };
  }

  return {
    displayText: response,
    speechText: getSpeechText(response)
  };
};